import { Link } from 'react-router-dom';
import { Button } from 'antd';

// TODO: Sistem genelinde bu geri butonlarinin standart hale getirlmesi icin global bir komponent olusturulmali
//  disardan url ve label alanlarini gondererek render olacak sekilde duzenlenebilir
function BackButton() {
  return (
    <Link to="/madde-iliskilendirme-yonetimi">
      <Button>Geri Dön</Button>
    </Link>
  );
}
export default BackButton;
